// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"58139545","165":"d1972f9a"}[chunkId] + ".chunk.js";
};